import { PropsWithChildren } from "react";

interface TableHeaderProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {}

export const TableHeader = ({ children, ...props }: TableHeaderProps) => {
  return (
    <div
      className="block sticky top-0 z-1"
      // boxShadow="0 1px 0 1px #E2E8F0"
      {...props}
    >
      {children}
    </div>
  );
};
